// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Support styles */

.section-body-support{
    width: 100%;
    max-width: 82vw;
    padding-top: 6rem;
    margin: auto;
    font-size: 1rem;
}

.support-title{
    padding: 1.4em 0 0 0.8em;
    color: var(--light-purple-sensedia);
    margin-bottom: 1.4em;
    text-align:justify;
    font-size: 4em;
}

.container-accordion{
    background-color: inherit;
    border-radius: 1em;
}

.container-accordion .accordion-body p{
    color: var(--grey);
    letter-spacing: 0.5px;
    line-height: 1.6em;
    margin-bottom: 1.4em;
}

/* Customers Monitored */

.list-clients{
    list-style: none;
    text-align: center;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1em;
    justify-content: center;
    align-items: center;
}

.clients-support img{
    width: 7em;
}

/* Alerts triggered */

.list-firing-alerts{
    margin-top: 1.6em;
    list-style: none;
}

.li-type-alerts{
    padding: 0em;
}

.p-type-alerts{
    position: relative;
    left: 2em;
    bottom: 1.4em;
}

/* Link */

.link-style{
    text-decoration: none;
}

/* Responsividade para distância do navbar e os diferentes section */

@media screen and (min-width:2200px){
    .section-body-support{
        padding-top: 8.2rem;
    }
}

@media screen and (min-width:1921px) and (max-width: 2200px){
    .section-body-support{
        padding-top: 7.4rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/support/section/style.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,wBAAwB;;AAExB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;;AAErB;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;;AAEA,SAAS;;AAET;IACI,qBAAqB;AACzB;;AAEA,oEAAoE;;AAEpE;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* Support styles */\n\n.section-body-support{\n    width: 100%;\n    max-width: 82vw;\n    padding-top: 6rem;\n    margin: auto;\n    font-size: 1rem;\n}\n\n.support-title{\n    padding: 1.4em 0 0 0.8em;\n    color: var(--light-purple-sensedia);\n    margin-bottom: 1.4em;\n    text-align:justify;\n    font-size: 4em;\n}\n\n.container-accordion{\n    background-color: inherit;\n    border-radius: 1em;\n}\n\n.container-accordion .accordion-body p{\n    color: var(--grey);\n    letter-spacing: 0.5px;\n    line-height: 1.6em;\n    margin-bottom: 1.4em;\n}\n\n/* Customers Monitored */\n\n.list-clients{\n    list-style: none;\n    text-align: center;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1em;\n    justify-content: center;\n    align-items: center;\n}\n\n.clients-support img{\n    width: 7em;\n}\n\n/* Alerts triggered */\n\n.list-firing-alerts{\n    margin-top: 1.6em;\n    list-style: none;\n}\n\n.li-type-alerts{\n    padding: 0em;\n}\n\n.p-type-alerts{\n    position: relative;\n    left: 2em;\n    bottom: 1.4em;\n}\n\n/* Link */\n\n.link-style{\n    text-decoration: none;\n}\n\n/* Responsividade para distância do navbar e os diferentes section */\n\n@media screen and (min-width:2200px){\n    .section-body-support{\n        padding-top: 8.2rem;\n    }\n}\n\n@media screen and (min-width:1921px) and (max-width: 2200px){\n    .section-body-support{\n        padding-top: 7.4rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
